import { render, staticRenderFns } from "./LogsTableSortSkeleton.vue?vue&type=template&id=4a12ff6a&scoped=true"
import script from "./LogsTableSortSkeleton.vue?vue&type=script&lang=js"
export * from "./LogsTableSortSkeleton.vue?vue&type=script&lang=js"
import style0 from "./LogsTableSortSkeleton.vue?vue&type=style&index=0&id=4a12ff6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a12ff6a",
  null
  
)

export default component.exports